import React, { useState } from 'react'

// mui
import TextField from '@mui/material/TextField'
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';

import SelectLocation from '../dialogs/SelectLocation'

// redux
import { useAppSelector, useAppDispatch } from '../../hooks'
import { getOrganizationLocations } from '../../managers/redux/slices/locations'

import { StaffProfile, Location, LocationType } from '../../API';

const locationFilter = createFilterOptions<Location>();

interface Props {
    onChange: (e: Location | null) => void,
    value: Location | null | undefined,
    searchText?: string,
    className?: string,
    label?: string
}

export default function LocationSelector(props: Props) {

    const [openLocationList, setOpenLocationList] = useState<boolean>(false)
    const [loadingLocations, setLoadingLocations] = useState<boolean>(false)
    const [showAddNewLocationDialog, setShowAddNewLocationDialog] = useState<boolean>(false)

    const dispatch = useAppDispatch()
    const locations = useAppSelector(state => state.locations)

    return (
        <>
            <Autocomplete
                id="asynchronous-demo"
                sx={{ width: 300 }}
                open={openLocationList}
                onOpen={async () => {
                    setLoadingLocations(true)
                    setOpenLocationList(true)
                    if (locations.organizationLocations && locations.organizationLocations.length == 0) {
                        await dispatch(getOrganizationLocations())
                    }
                    setLoadingLocations(false)
                }}
                onClose={() => {
                    setOpenLocationList(false)
                }}
                onChange={(e, value) => {
                    console.log('location changed: ', e, value)
                    if (typeof value !== 'string' && value && value.id == '00000000-0000-0000-0000-000000000000') {
                        setShowAddNewLocationDialog(true)
                    } else if (typeof value !== 'string' && value && value.id != '00000000-0000-0000-0000-000000000000') {
                        props.onChange(value)
                    }
                }}
                value={props.value}
                isOptionEqualToValue={(option: Location, value) => {
                    if (option.id == value.id) return true
                    else return false
                }}
                getOptionLabel={(option) => option.name ? option.name : ''}
                filterOptions={(options, params) => {
                    const filtered = locationFilter(options, params);

                    if (params.inputValue !== '') {
                        filtered.push({
                            id: '00000000-0000-0000-0000-000000000000',
                            name: `Add new location - ${params.inputValue}`,
                            type: LocationType.physical,
                            createdAt: '',
                            updatedAt: '',
                            __typename: "Location"
                        });
                    }

                    return filtered;
                }}
                options={locations.organizationLocations}
                loading={loadingLocations}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        placeholder="Select a location"
                        label={props.label ? props.label : ""}
                        sx={{ width: 400 }}
                        InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                                <React.Fragment>
                                    {loadingLocations ? <CircularProgress color="inherit" size={20} /> : null}
                                    {params.InputProps.endAdornment}
                                </React.Fragment>
                            ),
                        }}
                    />
                )}
                className={props.className}
            />
            <SelectLocation
                visible={showAddNewLocationDialog}
                onClose={(newLocation: Location | null) => {
                    setShowAddNewLocationDialog(false);
                    if (newLocation != null) {
                        props.onChange(newLocation)
                    }
                }}
                searchText={props.searchText ? props.searchText : null}
            />
        </>
    )
}